var map = {
	"./A2A.svg": 33747,
	"./MPG.svg": 36244,
	"./PBV.svg": 98827,
	"./accountant.svg": 61608,
	"./cash-in.svg": 23523,
	"./customer.svg": 17428,
	"./fee.svg": 16860,
	"./ipg.svg": 42663,
	"./kerdar.svg": 3124,
	"./log.svg": 26064,
	"./miando.svg": 6280,
	"./moghayerat.svg": 55281,
	"./p2p.svg": 52350,
	"./p2p_new.svg": 77435,
	"./pos.svg": 35701,
	"./reconciliation.svg": 10062,
	"./refund.svg": 32062,
	"./request-money.svg": 1345,
	"./requestMoney.svg": 21166,
	"./settlement.svg": 62161,
	"./settlement_batch.svg": 10004,
	"./subscription.svg": 14175,
	"./success.svg": 51153,
	"./tools.svg": 21474,
	"./total.svg": 88679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37090;